<template>
  <div class="filelist">
    <FileSee ref='FileSee' :info='info'></FileSee>
    <div class="table" v-for="(item, key) in allList" v-if="item.list.length">
      <table>
        <thead>
          <td width="40">序号</td>
          <td width='280'>文件名</td>
          <td width='60'>操作</td>
        </thead>
        <tbody>
          <tr v-for='(i, index) in item.list' :key="index">
            <td>{{ key * 5 + (index + 1) }}</td>
            <td>
              {{ i.origin_name }}
            </td>
            <td style="white-space: nowrap;">
              <!-- <a href='javascript:void(0);' class="see" v-if='Filetype(i.url)==3'>
                <viewer class="pimg"><img v-for="(decImg, ind) in imgList" :key="ind" :src="decImg.url" style="width: 100%;height: 100%;" :class='{"fir":decImg.index==index}'> </viewer>浏览
              </a> -->
              <a href='javascript:void(0);' class="see" @click='see(i)'>浏览</a>
              <span class="line" v-if='$common.AUTH("debtor:files:download")'></span>
              <a :href="downFile(i)" target="_blank" :download="i.origin_name"
                v-if='$common.AUTH("debtor:files:download")'>下载</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Tacitly } from '@/assets/js/Tacitly'
import FileSee from "@/components/filesee"
import {
  Filetype
} from "@/assets/js/unit"
export default {
  name: "File",
  props: {
    list: Array
  },
  data() {
    return {
      info: { //查看文件详情
        type: null,
        url: null,
        title: null
      },
    }
  },
  components: {
    FileSee
  },
  computed: {
    allList() {
      if (this.list) {
        let arr = { 0: { list: [] }, 1: { list: [] }, 2: { list: [] } }
        this.list.map((ele, index) => {
          if (index < 5) {
            arr[0].list.push(ele)
          }
          else if (index >= 5 && index < 10) {
            arr[1].list.push(ele)
          }
          else {
            arr[2].list.push(ele)
          }
        })
        return arr
      }
    },
    imgList() {
      if (this.list) {
        let fileList = JSON.parse(JSON.stringify(this.list))
        fileList.map((ele, index) => {
          ele.index = index
        })
        return fileList.filter(ele => {
          return Filetype(ele.url) == 3
        })
      } else {
        return []
      }
    }
  },
  methods: {
    downFile(i) {
      const baseUrl = process.env.NODE_ENV == "development" ? "https://demo.dyuit.cn/xiaoyin/index.php/api/" : Tacitly.Base_Port;
      return `${baseUrl}common/download?url=${encodeURIComponent(i.url)}&filename=${encodeURIComponent(i.title || i.origin_name)}`
    },
    Filetype,
    see(i) {
      if (Filetype(i.url) == 4) {
        window.open("https://view.officeapps.live.com/op/view.aspx?src=" + i.url)
      } else {
        this.info = {
          type: Filetype(i.url),
          url: i.url,
          title: i.title || i.origin_name,
        }
        this.$refs.FileSee.visible = true;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.table {
  border: 1px solid #DADADA;
  width: 48%;
  float: left;

  &:nth-child(even) {
    margin-right: 2%;
  }
}

.selectbox {
  position: relative;
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
  align-items: center;

  .lf {
    display: flex;
  }

  .input {
    margin-right: 30px;
  }
}

.see {
  position: relative;
  display: inline-block;

  .pimg {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .fir {
    z-index: 999;
  }

  img {
    opacity: 0;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
}
</style>